export class GlobalComponents {
    public static notSuccess: string = 'stt.search.notSuccess';
}